<script lang="ts">
	import { getContext } from "svelte";
	import IntersectionObserver from "@reperio-news/core.components/IntersectionObserver.svelte";
	import Hydrator from "@reperio-news/core.components/Hydrator.svelte";

	export let id: string;
	export let data: any;
	export let content: any = undefined;

	const context: SvelteStore<any> = getContext("context");

	if (!content) {
		if ($context.content) {
			content = $context.content.id;
		} else {
			content = $context.path;
		}
	}

	let intersecting: boolean = false;
	let element: HTMLIFrameElement;

	let loaded = false;

	//	element in the condition: it can be unbound mid-flight during the
	//	Hydrator branch swap, and the statement re-runs once it re-binds
	$: if (intersecting && element && !loaded) {
		// get id and some other stuff from window.location if no context (hydrating without context)
		// this needs improvement across the system or just use loading="lazy" when fully supported

		let domain = "";

		if (__ADMIN__) {
			domain =
				$context.domain_config.default.alternateDomain ||
				$context.domain_config.default.domain;
		} else {
			domain = window.location.host;
		}

		let url = `//${domain}/videoplayer/${data.video.id}?`;

		// make videos always work in admin even if content not published
		if (__ADMIN__) {
			url =
				url +
				"&_reperio_admin_video=" +
				encodeURIComponent(data.video.url);
		}

		if (data.player_options?.autoplay) {
			url += "&autoplay=1";
		}

		if (data.player_options?.loop) {
			url += "&loop=1";
		}

		if (data.player_options?.start) {
			url += "&start=" + encodeURIComponent(data.player_options.start);
		}

		if (data.player_options?.end) {
			url += "&end=" + encodeURIComponent(data.player_options.end);
		}

		if (!content) {
			const m = window.location.pathname.match(/\-(\d{1,})\.html/);
			if (m) {
				content = m[1];
			}
		}

		element.src = `${url}&content=${encodeURIComponent(content)}`;
		loaded = true;
	}
</script>

<Hydrator props={$$props} component="EditorVideoPlayer" hydrate={true}>
	<IntersectionObserver
		{element}
		bind:intersecting
		rootMargin="150vh"
		threshold={0.01}
	>
		<iframe
			class="videoPlayer"
			loading="lazy"
			{id}
			bind:this={element}
			allow="autoplay; fullscreen; picture-in-picture; xr-spatial-tracking; encrypted-media"
			title="video player"
			style={data.video.origin_width && data.video.origin_height
				? `--aspectRatio: ${
						data.video.origin_width / data.video.origin_height
				  };`
				: undefined}
		/>
	</IntersectionObserver>
</Hydrator>

<style>
	iframe {
		width: 100%;
		aspect-ratio: var(--aspectRatio, 16/9);
		max-height: calc(100vh - 150px);
		min-height: 250px;
		border: 1px solid #111;
		margin: 0 auto 10px auto;
	}
</style>
